import { Injectable } from '@angular/core';
import { OclLogbookTagService } from '../../../ocl/services/ocl-logbook-tag-service/ocl-logbook-tag.service';

@Injectable({
  providedIn: 'root',
})
export class GocLogbookTagService extends OclLogbookTagService {
  // tslint:disable:variable-name
  protected ParseLogBookTag = Parse.Object.extend('GOCLogBookTag');
  protected ParseLogBook = Parse.Object.extend('GOCLogBook');
  protected ParseTag = Parse.Object.extend('GOCTag');
  // tslint:enable
}
